import {ISelectValue} from "../../common/Select.component";

export enum AssetClassFilter {
    EQUITY = "Equity",
    LIQUID_ALTERNATIVE = "Liquid Alternatives",
    FIXED_INCOME = "Fixed Income",
    MULTIASSET_DGFTTAA = "Multi Asset",
    CASH = "Cash",
    TARGET_DATE_FUNDS = "Target Date Funds",
    REAL_ESTATE = "Real Estate",
    STABLE_VALUE = "Stable Value",
    ALL = "All",
}

export enum AssetClass {
    EQUITY = "Equity",
    LIQUID_ALTERNATIVE = "Liquid Alternatives",
    FIXED_INCOME = "Fixed Income",
    MULTIASSET_DGFTTAA = "Multi Asset",
    CASH = "Cash",
    TARGET_DATE_FUNDS = "Target Date Funds",
    REAL_ESTATE = "Real Estate",
    STABLE_VALUE = "Stable Value",
}

export const assetClassFilterItems: ISelectValue[] = [
    {id: AssetClassFilter.ALL, name: "All Asset Classes"},
    {id: AssetClassFilter.CASH, name: "Cash"},
    {id: AssetClassFilter.EQUITY, name: "Equity"},
    {id: AssetClassFilter.FIXED_INCOME, name: "Fixed Income"},
    {id: AssetClassFilter.LIQUID_ALTERNATIVE, name: "Liquid Alternatives"},
    {id: AssetClassFilter.MULTIASSET_DGFTTAA, name: "Multi Asset"},
    {id: AssetClassFilter.TARGET_DATE_FUNDS, name: "Target Date Funds"},
    {id: AssetClassFilter.REAL_ESTATE, name: "Real Estate"},
    {id: AssetClassFilter.STABLE_VALUE, name: "Stable Value"},
];

export enum RatingTypeFilter {
    ALL = "All",
    BUY = "Buy",
    SELL = "Sell",
    QUALIFIED = "Qualified",
    NR = "Not Recommended",
    IR = "In Review",
    NOT_RATED = "Not Rated",
}

export const AssetClassMapper: Record<string, AssetClass> = {
    "Equity": AssetClass.EQUITY,
    "LiquidAlternative": AssetClass.LIQUID_ALTERNATIVE,
    "Cash": AssetClass.CASH,
    "FixedIncome": AssetClass.FIXED_INCOME,
    "MultiAssetDgfTtaa": AssetClass.MULTIASSET_DGFTTAA,
    "TargetDateFunds": AssetClass.TARGET_DATE_FUNDS,
    "RealEstate": AssetClass.REAL_ESTATE,
    "StableValue": AssetClass.STABLE_VALUE,
};

export const AssetClassMapperReverse: Record<AssetClass, string> = {
    [AssetClass.EQUITY]: "Equity",
    [AssetClass.LIQUID_ALTERNATIVE]: "LiquidAlternative",
    [AssetClass.CASH]: "Cash",
    [AssetClass.FIXED_INCOME]: "FixedIncome",
    [AssetClass.MULTIASSET_DGFTTAA]: "MultiAssetDgfTtaa",
    [AssetClass.TARGET_DATE_FUNDS]: "TargetDateFunds",
    [AssetClass.REAL_ESTATE]: "RealEstate",
    [AssetClass.STABLE_VALUE]: "StableValue",
};